import { isGradientType } from '@shopify/polaris-viz-core';
import { createCSSGradient } from './createCssGradient.js';

function getCSSBackgroundFromColor(color, angle = 90) {
  return isGradientType(color) ? createCSSGradient(color, angle) : color;
}

export { getCSSBackgroundFromColor };
